/* About Universkin — scroll reveal.
   Progressive enhancement: without JS, .about-rv elements are visible
   because the stylesheet only hides them once .js-about-rv is on <html>. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = [].slice.call(document.querySelectorAll('.about-rv'));
  if (!els.length) return;

  if (!('IntersectionObserver' in window) || reduce) {
    els.forEach(function (el) { el.classList.add('in'); });
    return;
  }

  document.documentElement.classList.add('js-about-rv');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  els.forEach(function (el, i) {
    el.style.transitionDelay = Math.min(i % 4, 3) * 70 + 'ms';
    io.observe(el);
  });
})();

/* Process film. The element ships with preload="none" and no autoplay attribute,
   so nothing is fetched until it actually scrolls into view — it sits well below
   the fold. Play on entry, pause on exit.
   Under prefers-reduced-motion we never autoplay; the film gets native controls
   so it stays reachable without motion being forced on anyone. */
(function () {
  var video = document.querySelector('[data-about-reel]');
  if (!video) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    video.setAttribute('controls', '');
    return;
  }
  if (!('IntersectionObserver' in window)) {
    video.setAttribute('controls', '');
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        if (video.preload !== 'auto') video.preload = 'auto';
        var p = video.play();
        // Autoplay can still be refused; fall back to controls rather than a dead frame.
        if (p && typeof p.catch === 'function') {
          p.catch(function () { video.setAttribute('controls', ''); });
        }
      } else if (!video.paused) {
        video.pause();
      }
    });
  }, { threshold: 0.25 });

  io.observe(video);
})();

/* Founder video lightbox */
(function () {
  var lb = document.querySelector('[data-about-lightbox]');
  if (!lb) return;
  var triggers = [].slice.call(document.querySelectorAll('[data-about-video]'));
  if (!triggers.length) return;

  var video = lb.querySelector('.about-lightbox__video');
  var cap = lb.querySelector('.about-lightbox__cap');
  var closers = [].slice.call(lb.querySelectorAll('[data-about-lightbox-close]'));
  var xBtn = lb.querySelector('.about-lightbox__x');
  var lastFocus = null;

  function open(trigger) {
    lastFocus = trigger;
    video.src = trigger.getAttribute('href');
    var title = trigger.getAttribute('data-title') || '';
    var role = trigger.getAttribute('data-role') || '';
    cap.textContent = role ? (title + ' — ' + role) : title;
    lb.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (xBtn) xBtn.focus();
    var p = video.play();
    if (p && typeof p.catch === 'function') { p.catch(function () {}); }
  }

  function close() {
    video.pause();
    video.removeAttribute('src');
    video.load();
    lb.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus) { lastFocus.focus(); lastFocus = null; }
  }

  triggers.forEach(function (t) {
    t.addEventListener('click', function (e) { e.preventDefault(); open(t); });
  });
  closers.forEach(function (el) { el.addEventListener('click', close); });

  document.addEventListener('keydown', function (e) {
    if (lb.hidden) return;
    if (e.key === 'Escape' || e.keyCode === 27) { close(); return; }
    // Minimal focus trap: keep Tab within the close button while the dialog is open.
    if (e.key === 'Tab' && xBtn) { e.preventDefault(); xBtn.focus(); }
  });
})();
